import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { routes } from '@libs/utils';

export const TokenQueryParamAccessGuard: CanActivateFn = (next: ActivatedRouteSnapshot): UrlTree | boolean => {
  const router = inject(Router);
  const token = next.queryParams['token'];

  if (!token) return router.createUrlTree([routes.login]);
  return true;
};
